// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__tQams"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewaySFPie/styles.scss
// module id = 2268
// module chunks = 1